import React from "react";
import { Table } from "antd";

const EducationAttendanceLogs = ({ config }) => {

  const GateEntryExitTable = () => {

    const columns = [
      { title: "Staff ID", dataIndex: "staffId" },
      { title: "Name", dataIndex: "name" },
      { title: "Entry Time", dataIndex: "entryTime" },
      { title: "Exit Time", dataIndex: "exitTime" }
    ];

    const data = [];

    return (
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    );
  };

  const LateStaffTable = () => {

    const columns = [
      { title: "Staff ID", dataIndex: "staffId" },
      { title: "Name", dataIndex: "name" },
      { title: "Entry Time", dataIndex: "entryTime" },
      { title: "Delay", dataIndex: "delay" }
    ];

    const data = [];

    return (
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    );
  };

  /* ---------------- WIDGET REGISTRY ---------------- */

  const WIDGETS = {

    "Gate Entry Exit Logs": () => (
      <div className="bg-white p-6 rounded-xl shadow">
        <h3 className="text-lg font-semibold mb-4">
          Gate Entry Exit Logs
        </h3>
        <GateEntryExitTable />
      </div>
    ),

    "Late Staff List": () => (
      <div className="bg-white p-6 rounded-xl shadow">
        <h3 className="text-lg font-semibold mb-4">
          Late Staff List
        </h3>
        <LateStaffTable />
      </div>
    )

  };

  /* ---------------- RENDER ---------------- */

  return (

    <div className="max-w-7xl mx-auto">

      {config?.rows?.map((row, rowIdx) => (

        <div
          key={rowIdx}
          className={`grid grid-cols-${row.cards.length} gap-6 mb-6`}
        >

          {row.cards.map((card, idx) => {

            const Widget = WIDGETS[card.name];

            if (!Widget) return null;

            return (
              <div key={idx}>
                <Widget />
              </div>
            );

          })}

        </div>

      ))}

    </div>

  );

};

export default EducationAttendanceLogs;